import React from 'react'
import { Tooltip } from 'antd'
import avitoLogo from '../../assets/integrations/avito.svg'
import calltouchLogo from '../../assets/integrations/calltouch.svg'
import mangoLogo from '../../assets/integrations/mango.png'

export type IntegrationFlags = {
  mango: boolean
  calltouch?: boolean
  avito?: boolean
}

export type IntegrationServiceKey = keyof IntegrationFlags

const DEFAULT_FLAGS: Required<IntegrationFlags> = {
  mango: false,
  calltouch: false,
  avito: false,
}

const ALL_SERVICES: Array<{
  key: IntegrationServiceKey
  title: string
  src: string
}> = [
  { key: 'mango', title: 'Mango Office', src: mangoLogo as unknown as string },
  { key: 'avito', title: 'Авито', src: avitoLogo as unknown as string },
  { key: 'calltouch', title: 'Calltouch', src: calltouchLogo as unknown as string },
]

function iconWrapStyle(active: boolean, size: number): React.CSSProperties {
  return {
    width: size,
    height: size,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    filter: active ? undefined : 'grayscale(1) opacity(0.4)',
    lineHeight: 0,
  }
}

export function IntegrationIcons({
  integrations,
  size = 16,
  services = ['mango', 'avito', 'calltouch'],
}: {
  integrations?: Partial<IntegrationFlags> | null
  size?: number
  /** Какие сервисы показывать. Для сотрудника — только mango. */
  services?: IntegrationServiceKey[]
}) {
  const flags = { ...DEFAULT_FLAGS, ...(integrations || {}) }
  const visible = ALL_SERVICES.filter(service => services.includes(service.key))

  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}
      onClick={e => e.stopPropagation()}
    >
      {visible.map(service => {
        const active = Boolean(flags[service.key])
        return (
          <Tooltip
            key={service.key}
            title={`${service.title}: ${active ? 'настроено' : 'не настроено'}`}
          >
            <span style={iconWrapStyle(active, size)}>
              <img
                src={service.src}
                alt={service.title}
                width={size}
                height={size}
                draggable={false}
              />
            </span>
          </Tooltip>
        )
      })}
    </span>
  )
}
